export const LOCAL_STORAGE_CHANNEL_KEY = 'gtm_channel_id';

export const getChannel = () => localStorage.getItem(LOCAL_STORAGE_CHANNEL_KEY) ?? '';
export const saveChannel = (channelId: number) => localStorage.setItem(LOCAL_STORAGE_CHANNEL_KEY, channelId.toString());
